<!-- eslint-disable -->
<template>
  <v-card height="100%">
    <v-card-text>
      <v-form @submit.prevent="getAll" :disabled="loader">
        <v-row class="mb-3">
          <v-col cols="12" md="6">
            <v-text-field
              dense
              outlined
              clearable
              label="Buscar"
              hide-details="auto"
              v-model="paginado.search"
            />
          </v-col>
          <v-col>
            <v-btn color="info" type="submit" :disabled="loader">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-btn
              color="success"
              class="ml-2"
              @click="nuevo"
              :disabled="loader"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        dense
        mobile-breakpoint="0"
        hide-default-footer
        :headers="headers"
        :items="items"
        class="elevation-1"
        :loading="loader"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon color="primary" @click="getResource(item.id)">
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <paginado :paginado="paginado" :loader="loader" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Index",
  computed: {
    ...mapState({
      headers: state => state.Vehicles.headers,
      paginado: state => state.Vehicles.paginado,
      items: state => state.Vehicles.collection,
      loader: state => state.Vehicles.loader
    })
  },
  methods: {
    ...mapActions("Vehicles", ["nuevo", "getAll", "getResource"])
  },
  mounted() {
    this.getAll();
  }
};
</script>
